import React from 'react'
import { TextField, Typography, makeStyles, InputAdornment, IconButton } from '@material-ui/core'
import { InfoRounded } from '@material-ui/icons'
import Tooltip from '@material-ui/core/Tooltip'
import { Fade } from '@mui/material'

const FormTextField = ({
  infoText,
  error,
  helperText,
  value,
  onChange,
  onBlur,
  name,
  ...props
}) => {
  const classes = useStyles()

  return (
    <TextField
      className={`${props.disabled ? classes.disabled : ''} ${classes.textField} ${
        props.className || ''
      }`}
      name={name}
      value={value || ''}
      onChange={onChange}
      onBlur={onBlur}
      helperText={helperText}
      error={!!error}
      fullWidth
      variant="outlined"
      {...props}
      InputProps={{
        classes: {
          root: classes.inputRoot,
          focused: classes.inputFocused
        },
        endAdornment: (
          <>
            {infoText && (
              <InputAdornment position="end">
                <Tooltip
                  arrow
                  TransitionComponent={Fade}
                  title={<Typography className={classes.tooltip}>{infoText}</Typography>}>
                  <IconButton className={classes.infoIconBtn}>
                    <InfoRounded className={classes.infoIcon} />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            )}
          </>
        ),
        ...props.InputProps
      }}
      InputLabelProps={{
        classes: {
          root: classes.labelRoot,
          focused: classes.labelFocused
        },
        ...props.InputLabelProps
      }}
    />
  )
}

export default FormTextField

const useStyles = makeStyles({
  textField: {
    marginBottom: '8px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      transition: 'all 0.3s',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#15b4db'
      }
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#e0e0e0',
      borderWidth: '1px'
    }
  },
  disabled: {
    '& .MuiFormLabel-root': {
      color: '#616161'
    },
    '& .MuiInputBase-root': {
      color: '#616161'
    },
    backgroundColor: '#f5f5f5',
    borderRadius: '8px'
  },
  inputRoot: {
    fontSize: '14px',
    padding: '2px',
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#15b4db',
      borderWidth: '2px'
    }
  },
  inputFocused: {
    // boxShadow: '0 0 0 3px rgba(21, 180, 219, 0.1)'
  },
  labelRoot: {
    fontSize: '14px',
    '&.Mui-focused': {
      color: '#15b4db'
    }
  },
  labelFocused: {
    color: '#15b4db !important'
  },
  tooltip: {
    padding: '5px',
    fontSize: '13px'
  },
  infoIcon: {
    color: '#1e88e5'
  },
  infoIconBtn: {
    padding: '2px'
  }
})
